/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/news'
export default icon
